import { motion } from "framer-motion";

export default function QuiSommesNous() {
  return (
    <motion.div
      id="main"
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -10 }}
      transition={{
        duration: 1,
      }}
    >
      <div className="left">
        <h1 className="orange">
          Groupe de catéchèse spécialisée sur le diocèse de Paris.
        </h1>
        <p>
          Hand Amitié est une association proposant une catéchèse spécialisée,
          c'est-à-dire s'adressant aux personnes avec un handicap mental.
        </p>
        <p>Nous nous adressons aux adultes entre 25 et 60 ans.</p>
        <p>
          Nous nous voyons avant tout comme un groupe de rencontre, certes un
          peu particulier à au moins deux égards :<br />
          nous accueillons des personnes avec un handicap, et nous nous
          retrouvons autour de la parole de Dieu.
        </p>
        <p>Cette dernière folie est en fait la plus grande.</p>
        <h1 className="orange">Créé en 2000 à la suite des JMJ de Rome</h1>
        <p>
          Le groupe a été créé au retour des JMJ de Rome, il y a un peu plus de
          20 ans.
        </p>
        <p>
          Ce sont plus d'une cinquantaine d'animateurs qui se sont succédés pour
          permettre à ce groupe de continuer.
        </p>
        <h1 className="orange">Une trentaine de membres</h1>
        <p>
          Aujourd'hui, Hand Amitié, c'est une vingtaine de personnes avec un
          handicap accueillies par une dizaine d'animateurs...
        </p>
        <p>
          ...enfin, dans ce groupe, nous nous demandons encore qui accueille
          qui.
        </p>
        <p>
          Et si vous nous demandez qui accompagne qui sur le chemin du Christ,
          nous serions encors plus embêtés pour vous répondre !
        </p>
        <p>Nous le faisons ensemble.</p>
        <h1 className="orange">Et demain...</h1>
        <p>
          ...Hand Amitié ce sera le fruit de ce chemin et de ces rencontres
          ensemble, de chacun, et peut-être de toi ?
        </p>
      </div>
    </motion.div>
  );
}
